import { render, staticRenderFns } from "./dictionaryDetail.vue?vue&type=template&id=70fbdd2f&scoped=true"
import script from "./dictionaryDetail.vue?vue&type=script&lang=js"
export * from "./dictionaryDetail.vue?vue&type=script&lang=js"
import style0 from "./dictionaryDetail.vue?vue&type=style&index=0&id=70fbdd2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fbdd2f",
  null
  
)

export default component.exports